export default "/images/7f9aaef57585c59557777db2faf7aa59.avif";